





































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Modal extends Vue {
	@Prop({ default: true }) public value!: boolean
	@Prop({ default: false }) public confirmModal!: boolean

	get isMobile() {
		return this.$store.getters.isMobile
	}

	private close() {
		this.$emit('input', false)
		this.$emit('cancel')
	}
	private wrapperClick() {
		if (this.confirmModal || this.isMobile) {
			return
		}
		this.close()
	}
}
